"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UefaApiTemplateDataFromJSON = UefaApiTemplateDataFromJSON;
exports.UefaApiTemplateDataFromJSONTyped = UefaApiTemplateDataFromJSONTyped;
exports.UefaApiTemplateDataToJSON = UefaApiTemplateDataToJSON;
exports.UefaApiTemplateDataToJSONTyped = UefaApiTemplateDataToJSONTyped;
const runtime_1 = require("../runtime");
function UefaApiTemplateDataFromJSON(json) {
    return UefaApiTemplateDataFromJSONTyped(json, false);
}
function UefaApiTemplateDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'templates': !(0, runtime_1.exists)(json, 'templates') ? undefined : json['templates'],
        'additionalProperties': !(0, runtime_1.exists)(json, 'additionalProperties') ? undefined : json['additionalProperties'],
    };
}
function UefaApiTemplateDataToJSON(value) {
    return UefaApiTemplateDataToJSONTyped(value, false);
}
function UefaApiTemplateDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'templates': value.templates,
        'additionalProperties': value.additionalProperties,
    };
}
